jQuery( document ).ready( function() {
	let selectedAmenities = [];
	let selectedRegions = [];
	let selectedBedrooms = [];
	let selectedPropertyType = [];
	let selectedTypeOfStay = [];
	let selectedGuestCapacity = [];
	let selectedSize = [];
	let paged = 1;
	let minVal;
	let maxVal;
	let keyword;
	let order = 'price_asc';
	let typingTimer;
	const typingDelay = 3000;

	// Function to check if any filter is active
	function toggleClearButton() {
		if (
			selectedAmenities.length ||
			selectedRegions.length ||
			selectedBedrooms.length ||
			selectedPropertyType.length ||
			selectedTypeOfStay.length ||
			selectedGuestCapacity.length ||
			selectedSize.length ||
			( keyword && keyword.trim() !== '' ) ||
			( minVal != null && minVal !== '' ) ||
			( maxVal != null && maxVal !== '' )
		) {
			jQuery( '.clear-filter-button' ).show();
		} else {
			jQuery( '.clear-filter-button' ).hide();
		}
	}

	// Clear filter click - reload the page
	jQuery( document ).on( 'click', '.clear-filter-button', function() {
		location.reload(); // Reload to reset everything
	} );

	function initMap( staysData ) {
		let center;
		if ( staysData[ 0 ] && staysData[ 0 ].lat && staysData[ 0 ].lng ) {
			center = {
				lat: parseFloat( staysData[ 0 ].lat ),
				lng: parseFloat( staysData[ 0 ].lng ),
			};
		} else {
			center = { lat: -25.2744, lng: 133.7751 };
		}

		const map = new google.maps.Map( document.getElementById( 'single-stay-map' ), {
			zoom: 6,
			center,
		} );

		if ( staysData ) {
			staysData.forEach( ( stay ) => {
				if ( stay.lat && stay.lng ) {
					new google.maps.Marker( {
						position: { lat: parseFloat( stay.lat ), lng: parseFloat( stay.lng ) },
						map,
						title: `Post ID: ${ stay.post_id }`,
					} );
				}
			} );
		} else {
			new google.maps.Marker( { map } );
		}
	}

	// Keyword search with delay
	jQuery( '#s' ).on( 'input', function() {
		clearTimeout( typingTimer );
		keyword = jQuery( this ).val();
		toggleClearButton();

		typingTimer = setTimeout( function() {
			sendAjaxRequest();
		}, typingDelay );
	} );

	// Checkbox filters
	jQuery( '.popular-filter-item' ).on( 'change', function() {
		selectedAmenities = [];
		selectedRegions = [];
		selectedBedrooms = [];
		selectedSize = [];
		selectedPropertyType = [];
		selectedTypeOfStay = [];
		selectedGuestCapacity = [];

		jQuery( '.popular-filter-item:checked' ).each( function() {
			const key = jQuery( this ).data( 'key' );
			const value = jQuery( this ).attr( 'id' );
			if ( key == 'amenities' ) {
				selectedAmenities.push( value );
			}
			if ( key == 'region' ) {
				selectedRegions.push( value );
			}
			if ( key == 'size' ) {
				selectedSize.push( value );
			}
			if ( key == 'property-type' ) {
				selectedPropertyType.push( value );
			}
			if ( key == 'type-of-stay' ) {
				selectedTypeOfStay.push( value );
			}
			if ( key == 'bedrooms' ) {
				selectedBedrooms.push( value );
				// console.log( selectedBedrooms );
			}
		} );

		toggleClearButton();
		sendAjaxRequest();

		const targetY = jQuery( 'body' ).hasClass( 'logged-in' )
			? jQuery( '#stayspage' ).offset().top - 280
			: jQuery( '#stayspage' ).offset().top - 260;

		jQuery( 'html, body' ).animate( { scrollTop: targetY } );
	} );

	// Pagination
	function pagination() {
		jQuery( '.stays-pagination' ).on( 'click', 'button[data-page]', function( e ) {
			e.preventDefault();
			paged = jQuery( this ).data( 'page' );
			console.log( paged );
			if ( paged ) {
				sendAjaxRequest();

				const targetY = jQuery( 'body' ).hasClass( 'logged-in' )
					? jQuery( '#stayspage' ).offset().top - 280
					: jQuery( '#stayspage' ).offset().top - 260;

				jQuery( 'html, body' ).animate( { scrollTop: targetY } );
			}
		} );
	}
	pagination();

	// Order buttons
	jQuery( '.ajax-order' ).on( 'click', function() {
		order = jQuery( this ).data( 'value' );
		toggleClearButton();
		sendAjaxRequest();
	} );

	// Range sliders
	const $rangeInputs = jQuery( ".ajax-stay-range-slider input[type='range']" );
	const $minValueDisplay = jQuery( '.minimum .value' );
	const $maxValueDisplay = jQuery( '.maximum .value' );

	function updateRangeValues() {
		minVal = parseInt( $rangeInputs.eq( 0 ).val() );
		maxVal = parseInt( $rangeInputs.eq( 1 ).val() );

		// console.log( minVal );
		// console.log( maxVal );

		if ( minVal > maxVal ) {
			[ minVal, maxVal ] = [ maxVal, minVal ];
		}

		$minValueDisplay.text( `$${ minVal }` );
		if ( maxVal === 800 ) {
			$maxValueDisplay.text( `$${ maxVal }+` );
		} else {
			$maxValueDisplay.text( `$${ maxVal }` );
		}
	}

	$rangeInputs.on( 'change', function() {
		updateRangeValues();
		toggleClearButton();
		sendAjaxRequest();
		jQuery( '.js-mobile-filter-button.filter-dropdown-button' ).removeClass( 'is-button-opened' );
	} );

	// Main AJAX request
	function sendAjaxRequest() {
		jQuery( '.loader-container' ).show();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'stays_filter',
				selectedAmenities,
				selectedRegions,
				selectedBedrooms,
				selectedSize,
				selectedPropertyType,
				selectedTypeOfStay,
				selectedGuestCapacity,
				minVal,
				maxVal,
				keyword,
				paged,
				order,
			},
			success( response ) {
				console.log( response );
				jQuery( '.loader-container' ).hide();
				jQuery( '#stays-container' ).html( response.html );
				if ( response.pagination !== null ) {
					jQuery( '#ajax-stays-pagination' ).html( response.pagination );
				} else {
					jQuery( '#ajax-stays-pagination' ).empty();
				}
				pagination();
				initMap( response.map_data );
				toggleClearButton();
			},
			error( xhr, status, error ) {
				jQuery( '.loader-container' ).hide();
				console.error( 'AJAX Error:', error );
				alert( 'Something went wrong. Please try again.' );
			},
		} );
	}
} );
